import { useContext } from "react";
import { EBSSSLayoutContext } from ".";
import { IEBSSSLayoutContext } from "./types";

export const useEBSSSLayout = () =>
  useContext<IEBSSSLayoutContext>(EBSSSLayoutContext);
